import { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Dialog } from '~ui-kit';

// import { useToast } from '~features/toast';
import { logOut } from '~actions/rootActions';

import OnboardingSelectPage from './OnboardingSelectPage';
import OnboardingRequestPermissionsPage from './OnboardingRequestPermissionsPage';
import OnboardingRequestDonePage from './OnboardingRequestDonePage';

const Onboarding = () => {
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(true);
  const closeModal = () => {
    setShowModal(false);
    dispatch(logOut);
  };

  return (
    <Dialog show={showModal} onClose={closeModal}>
      <Routes>
        <Route path="" element={<OnboardingSelectPage />} />
        <Route path="lupa" element={<OnboardingRequestPermissionsPage />} />
        <Route path="valmis" element={<OnboardingRequestDonePage />} />
      </Routes>
    </Dialog>
  );
};

export default Onboarding;
